
import { actionAddManualAction } from '@/api/action';
import { ActionsAddManualActionMutationVariables, Risolto_Action_Status_Enum } from '@/generated/graphql';

export default {
	props: {
		visible: { type: Boolean, required: true },
		legalEntity: { type: String, required: true },
		recipient: { type: String, required: true },
		invoices: { type: Array, required: true },
		dialogClose: { type: Function, required: false, default: undefined }
	},
	data() {
		return {
			loading: false,
			channels: [
				'PHONE'
			],
			form: {
				channel: 'PHONE',
				reason: '',
				assignee: 'unassigned',
				start_time: undefined
			}
		};
	},
	computed: {
		mutationVariables(): ActionsAddManualActionMutationVariables {
			const oldestInvoice = this.invoices.reduce((acc, current) => {
				if (current.issue_date < acc.issue_date) {
					acc = current;
				}

				return acc;
			});
			return {
				participant: this.$store.state.risolto.selectedParticipantStore,
				legalEntity: this.legalEntity,
				recipient: this.recipient,
				primaryInvoice: oldestInvoice.reference,
				invoiceGroupInvoices: this.invoices.map((invoice) => {
					return {
						invoice: invoice.reference,
						participant: this.$store.state.risolto.selectedParticipantStore,
						legal_entity: this.legalEntity,
						recipient: this.recipient
					};
				}),
				channel: this.form.channel,
				status: (this.form.start_time <= new Date()) ? Risolto_Action_Status_Enum.Open : Risolto_Action_Status_Enum.Draft,
				assignee: this.form.assignee !== 'unassigned' ? this.form.assignee : null,
				startTime: this.form.start_time,
				metadata: {
					channels: [{
						channel: this.form.channel,
						reason: this.form.reason
					}]
				}
			};
		}
	},
	methods: {
		handleClose() {
			if (this.dialogClose) {
				this.dialogClose();
			}
		},

		async onSubmit() {
			if (this.loading) {
				return;
			}
			this.loading = true;

			actionAddManualAction(this.mutationVariables).then(response => {
				this.$notify({
					title: this.$t('success'),
					message: this.$t('phoneAction'),
					type: 'success'
				});
				this.handleClose();
			}).finally(() => {
				this.loading = false;
			});
		}
	}
};
